// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__25yKh","boxTitle":"Qualiphy_boxTitle__21Vko","box":"Qualiphy_box__3Eq4Y","toggleWrap":"Qualiphy_toggleWrap__O7Ske"};